import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
  width: 100%;
`;

export const PaymentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  max-width: 400px;
  width: 100%;
`;

export const SelectContainer = styled.div`
  padding: 0 10px;
  width: 100%;
`;

export const CardInfo = styled.div`
  display: flex;
  width: 100%;
`;

export const CardImage = styled.div`
  position: relative;
  left: -24px;
  transform: scale(0.2);
  margin: 0;
  height: 0px;
  width: 90px;
`;

export const CheckboxContainer = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    cursor: pointer;
    display: flex;
    font-size: ${theme.v2.font.sizes.xxs};
    gap: 8px;
  `};
`;

export const CardData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardLastFour = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
  `};
`;

export const CardDueDate = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxxs};
    margin: 0;
  `};
`;

export const BottomMessage = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.brand.primaryLowLight};
    border-radius: 4px;
    display: flex;
    gap: 8px;
    padding: 8px;
    width: 100%;
  `};
`;

export const BottomMessageText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;
